"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _momentTimezone = babelHelpers.interopRequireDefault(require("moment-timezone"));

var _NodeTarget = require("NodeTarget");

var _Discussion = require("../Discussion");

var _class, _class2, _descriptor, _temp, _class4, _class5, _descriptor2, _temp2, _class7, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp3;

var NullFn = function NullFn() {
  return null;
};

var ZoneList = {
  "Pago Pago": "Pacific/Pago_Pago",
  "Hawaii Time": "Pacific/Honolulu",
  "Pacific Time": "America/Los_Angeles",
  "Pacific Time - Tijuana": "America/Tijuana",
  "Mountain Time": "America/Denver",
  "Mountain Time - Arizona": "America/Phoenix",
  "Mountain Time - Chihuahua, Mazatlan": "America/Mazatlan",
  "Central Time": "America/Chicago",
  "Central Time - Mexico City": "America/Mexico_City",
  "Central Time - Regina": "America/Regina",
  "Guatemala": "America/Guatemala",
  "Bogota": "America/Bogota",
  "Eastern Time": "America/New_York",
  "Lima": "America/Lima",
  "Caracas": "America/Caracas",
  "Atlantic Time - Halifax": "America/Halifax",
  "Guyana": "America/Guyana",
  "La Paz": "America/La_Paz",
  "Buenos Aires": "America/Argentina/Buenos_Aires",
  "Godthab": "America/Godthab",
  "Montevideo": "America/Montevideo",
  "Newfoundland Time - St. Johns": "America/St_Johns",
  "Santiago": "America/Santiago",
  "Sao Paulo": "America/Sao_Paulo",
  "South Georgia": "Atlantic/South_Georgia",
  "Azores": "Atlantic/Azores",
  "Cape Verde": "Atlantic/Cape_Verde",
  "Casablanca": "Africa/Casablanca",
  "Dublin": "Europe/Dublin",
  "Lisbon": "Europe/Lisbon",
  "London": "Europe/London",
  "Monrovia": "Africa/Monrovia",
  "Algiers": "Africa/Algiers",
  "Amsterdam": "Europe/Amsterdam",
  "Berlin": "Europe/Berlin",
  "Brussels": "Europe/Brussels",
  "Budapest": "Europe/Budapest",
  "Central European Time - Belgrade": "Europe/Belgrade",
  "Central European Time - Prague": "Europe/Prague",
  "Copenhagen": "Europe/Copenhagen",
  "Madrid": "Europe/Madrid",
  "Paris": "Europe/Paris",
  "Rome": "Europe/Rome",
  "Stockholm": "Europe/Stockholm",
  "Vienna": "Europe/Vienna",
  "Warsaw": "Europe/Warsaw",
  "Athens": "Europe/Athens",
  "Bucharest": "Europe/Bucharest",
  "Cairo": "Africa/Cairo",
  "Jerusalem": "Asia/Jerusalem",
  "Johannesburg": "Africa/Johannesburg",
  "Helsinki": "Europe/Helsinki",
  "Kiev": "Europe/Kiev",
  "Moscow-01 - Kaliningrad": "Europe/Kaliningrad",
  "Riga": "Europe/Riga",
  "Sofia": "Europe/Sofia",
  "Tallinn": "Europe/Tallinn",
  "Vilnius": "Europe/Vilnius",
  "Istanbul": "Europe/Istanbul",
  "Baghdad": "Asia/Baghdad",
  "Nairobi": "Africa/Nairobi",
  "Minsk": "Europe/Minsk",
  "Riyadh": "Asia/Riyadh",
  "Moscow+00 - Moscow": "Europe/Moscow",
  "Tehran": "Asia/Tehran",
  "Baku": "Asia/Baku",
  "Moscow+01 - Samara": "Europe/Samara",
  "Tbilisi": "Asia/Tbilisi",
  "Yerevan": "Asia/Yerevan",
  "Kabul": "Asia/Kabul",
  "Karachi": "Asia/Karachi",
  "Moscow+02 - Yekaterinburg": "Asia/Yekaterinburg",
  "Tashkent": "Asia/Tashkent",
  "Colombo": "Asia/Colombo",
  "Almaty": "Asia/Almaty",
  "Dhaka": "Asia/Dhaka",
  "Rangoon": "Asia/Rangoon",
  "Bangkok": "Asia/Bangkok",
  "Jakarta": "Asia/Jakarta",
  "Moscow+04 - Krasnoyarsk": "Asia/Krasnoyarsk",
  "China Time - Beijing": "Asia/Shanghai",
  "Hong Kong": "Asia/Hong_Kong",
  "Kuala Lumpur": "Asia/Kuala_Lumpur",
  "Moscow+05 - Irkutsk": "Asia/Irkutsk",
  "Singapore": "Asia/Singapore",
  "Taipei": "Asia/Taipei",
  "Ulaanbaatar": "Asia/Ulaanbaatar",
  "Western Time - Perth": "Australia/Perth",
  "Moscow+06 - Yakutsk": "Asia/Yakutsk",
  "Seoul": "Asia/Seoul",
  "Tokyo": "Asia/Tokyo",
  "Central Time - Darwin": "Australia/Darwin",
  "Eastern Time - Brisbane": "Australia/Brisbane",
  "Guam": "Pacific/Guam",
  "Moscow+07 - Magadan": "Asia/Magadan",
  "Moscow+07 - Yuzhno-Sakhalinsk": "Asia/Vladivostok",
  "Port Moresby": "Pacific/Port_Moresby",
  "Central Time - Adelaide": "Australia/Adelaide",
  "Eastern Time - Hobart": "Australia/Hobart",
  "Eastern Time - Melbourne, Sydney": "Australia/Sydney",
  "Guadalcanal": "Pacific/Guadalcanal",
  "Noumea": "Pacific/Noumea",
  "Majuro": "Pacific/Majuro",
  "Moscow+09 - Petropavlovsk-Kamchatskiy": "Asia/Kamchatka",
  "Auckland": "Pacific/Auckland",
  "Fakaofo": "Pacific/Fakaofo",
  "Fiji": "Pacific/Fiji",
  "Tongatapu": "Pacific/Tongatapu",
  "Apia": "Pacific/Apia"
};
var Dropdown = (_class =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Dropdown, _Component);

  function Dropdown() {
    babelHelpers.classCallCheck(this, Dropdown);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Dropdown).apply(this, arguments));
  }

  babelHelpers.createClass(Dropdown, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          required = _this$props.required,
          options = _this$props.options,
          disabled = _this$props.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("select", {
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        onChange: this.setValue,
        value: this.props.value,
        disabled: disabled
      }, options.map(function (_ref) {
        var _ref2 = babelHelpers.slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return _react.default.createElement("option", {
          key: key,
          value: key
        }, value);
      })), _react.default.createElement("span", null));
    }
  }]);
  return Dropdown;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype)), _class);
var TimeZone = (_class2 = (_temp =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(TimeZone, _Component2);

  function TimeZone() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, TimeZone);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(TimeZone)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "currentTime", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this._zoneData = {};
    _this._zoneCache = {};
    return _this;
  }

  babelHelpers.createClass(TimeZone, [{
    key: "render",
    value: function render() {
      if (!this._zoneData[this.currentTime]) {
        var m = (0, _momentTimezone.default)(this.currentTime);
        var zl = Object.keys(ZoneList).map(function (name) {
          return [Number(m.tz(ZoneList[name]).format('ZZ')), ZoneList[name], "(GMT".concat(m.tz(ZoneList[name]).format('Z'), ") ").concat(name)];
        });
        zl.sort(function (left, right) {
          return left[0] - right[0];
        });
        zl = zl.map(function (_ref3) {
          var _ref4 = babelHelpers.slicedToArray(_ref3, 3),
              x = _ref4[0],
              a = _ref4[1],
              b = _ref4[2];

          return [a, b];
        });
        var k = JSON.stringify(zl);
        if (this._zoneCache[k]) zl = this._zoneCache[k];
        this._zoneData[this.currentTime] = zl;
      }

      return _react.default.createElement(Dropdown, {
        id: this.props.id,
        text: this.props.text,
        setValue: this.props.setValue,
        required: this.props.required,
        options: this._zoneData[this.currentTime],
        disabled: this.props.disabled,
        value: this.props.value
      });
    }
  }]);
  return TimeZone;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class2.prototype, "currentTime", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2);
var DateTime = (_class4 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(DateTime, _Component3);

  function DateTime() {
    babelHelpers.classCallCheck(this, DateTime);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(DateTime).apply(this, arguments));
  }

  babelHelpers.createClass(DateTime, [{
    key: "setValue",
    value: function setValue(event) {
      var theValue = new Date(event.target.value);

      var d = _momentTimezone.default.tz({
        year: theValue.getFullYear(),
        month: theValue.getMonth(),
        date: theValue.getDate(),
        hour: theValue.getHours(),
        minute: theValue.getMinutes()
      }, this.props.timeZone);

      this.props.setValue(this.props.id, d.valueOf());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          required = _this$props2.required,
          minimumValue = _this$props2.minimumValue,
          text = _this$props2.text,
          value = _this$props2.value,
          timeZone = _this$props2.timeZone,
          disabled = _this$props2.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        required: required,
        disabled: disabled,
        ref: this.gotField
      }));
    }
  }, {
    key: "setFieldValue",
    value: function setFieldValue() {
      if (this._inputField) {
        var m = _momentTimezone.default.tz(this.props.value, this.props.timeZone);

        this._inputField.value = m.format('MMMM D, YYYY h:mm A');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value != this.props.value || prevProps.timeZone != this.props.timeZone) {
        this.setFieldValue();
      }
    }
  }, {
    key: "gotField",
    value: function gotField(field) {
      if (field != this._inputField) {
        console.log('ref changed: ', this._inputField, ' -> ', field);
      }

      this._inputField = field;

      if (field) {
        this.setFieldValue();
        $(field).change(this.setValue).datetimepicker({
          mode: 'datetime',
          hideTime: false
        });
      }
    }
  }]);
  return DateTime;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class4.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class4.prototype, "setValue"), _class4.prototype), babelHelpers.applyDecoratedDescriptor(_class4.prototype, "gotField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class4.prototype, "gotField"), _class4.prototype)), _class4);
var EventScheduleBody = (_class5 = (_temp2 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(EventScheduleBody, _Component4);

  function EventScheduleBody() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, EventScheduleBody);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(EventScheduleBody)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "node", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(EventScheduleBody, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement("div", {
        className: "comment"
      }, _react.default.createElement("div", {
        className: "comment-text"
      }, _react.default.createElement("p", null, "Following are the days and times that work best for me:", [['sun', 'Sunday'], ['mon', 'Monday'], ['tue', 'Tuesday'], ['wed', 'Wednesday'], ['thu', 'Thursday'], ['fri', 'Friday'], ['sat', 'Saturday']].map(function (_ref5) {
        var _ref6 = babelHelpers.slicedToArray(_ref5, 2),
            key = _ref6[0],
            day = _ref6[1];

        if (_this3.node.schedule[key]) {
          var f = day;
          var g = ['Morning', 'Afternoon', 'Evening'].filter(function (v) {
            return _this3.node.schedule[key][v.toLowerCase()];
          });

          if (g.length) {
            if (g.length == 1) return "".concat(f, " - ").concat(g[0]);
            if (g.length == 2) return "".concat(f, " - ").concat(g.join(' or '));
            return "".concat(f, " - any time");
          }
        }

        return null;
      }).filter(function (v) {
        return !!v;
      }).map(function (v, i) {
        return _react.default.createElement("span", {
          key: i
        }, _react.default.createElement("br", null), v);
      })), _react.default.createElement("p", null, "My timezone is:", _react.default.createElement("br", null), this.formatZone(this.node.timeZone)), this.props.children && _react.default.createElement("p", null, "Comments:", _react.default.createElement("br", null), _react.default.createElement("span", {
        style: {
          whiteSpace: 'pre-line'
        }
      }, this.props.children))));
    }
  }, {
    key: "formatZone",
    value: function formatZone(zone) {
      var mt = _momentTimezone.default.tz(Date.now(), zone);

      var zt = mt.format('Z');
      var f = Object.keys(ZoneList).filter(function (k) {
        return ZoneList[k] == zone;
      }).shift();
      return "".concat(f, " (GMT").concat(zt, ")");
    }
  }]);
  return EventScheduleBody;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class5);
var EventScheduleNode = (_class7 = (_temp3 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(EventScheduleNode, _Component5);

  function EventScheduleNode() {
    var _babelHelpers$getProt3;

    var _this4;

    babelHelpers.classCallCheck(this, EventScheduleNode);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(EventScheduleNode)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "node", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "commentPosted", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "defaultCollapsed", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "trackData", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "discussion", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    _this4.minimumValue = (0, _momentTimezone.default)().startOf('day').valueOf();
    _this4.state = {
      expanded: false,
      userProfile: null,
      submitting: false,
      action: 'reply',
      // this.node.node.permissions.moderate ? 'eventScheduleResponse' : 'reply',
      timeZone: _this4.node.node.timeZone,
      startTime: (0, _momentTimezone.default)().startOf('hour').add(1, 'hour').valueOf(),
      collapsed: _this4.defaultCollapsed
    };
    return _this4;
  }

  babelHelpers.createClass(EventScheduleNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(document).on('profileUpdated', this.profileUpdatedEvent);
      (0, _userProfile.getUserProfile)().then(this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated', this.profileUpdatedEvent);
    }
  }, {
    key: "profileUpdatedEvent",
    value: function profileUpdatedEvent(event) {
      this.profileUpdated(event.profile);
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(profile) {
      this.setState({
        userProfile: profile
      });
    }
  }, {
    key: "doPostComment",
    value: function doPostComment(comment) {
      return (0, _fetch.default)('data/discussion/post', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(Object.assign({
          child_type: this.state.action,
          parent: this.node.node.id,
          comment: comment
        }, this.state.action == 'eventScheduleResponse' ? {
          eventUTCStart: this.state.startTime,
          eventUTCEnd: this.state.startTime,
          eventTimezone: this.state.timeZone,
          eventIsAllDay: 0
        } : {}))
      }).then(function (result) {
        if (result.status == 204) return true;
        if (result.ok) return result.json();
        throw result.json();
      });
    }
  }, {
    key: "submitComment",
    value: function submitComment(comment) {
      var _this5 = this;

      return new _promisePolyfill.default(function (resolve, reject) {
        _this5.setState({
          submitting: true
        }, function () {
          _this5.doPostComment(comment).then(function (result) {
            var pa = _this5.state.action;

            _this5.setState({
              submitting: false,
              action: _this5.node.node.permissions.moderate ? 'eventScheduleResponse' : 'reply'
            }, function () {
              if (pa == 'reply') (0, _noty.showNotificationText)('Your comment has been posted.');else (0, _noty.showNotificationText)('Your scheduled time has been sent.');

              _this5.commentPosted();

              resolve(true);
            });
          }).catch(function (error) {
            _this5.setState({
              submitting: false
            }, function () {
              reject(error);
            });
          });
        });
      });
    }
  }, {
    key: "setAction",
    value: function setAction(node) {
      this.setState({
        action: node.target.value
      });
    }
  }, {
    key: "expand",
    value: function expand() {
      this.setState({
        collapsed: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      if (this.node) {
        return _react.default.createElement(_NodeTarget.Root, null, function (Target, Element) {
          return _react.default.createElement("div", {
            className: "comment-thread"
          }, _react.default.createElement(_node.default, {
            node: _this6.node.node,
            collapsed: _this6.state.collapsed,
            discussion: _this6.discussion,
            expand: _this6.expand,
            menu: _this6.node.node.permissions.delete ? [{
              title: 'Delete',
              invoke: _this6.doDelete
            }] : [],
            oldFooter: _react.default.createElement("footer", null, _react.default.createElement("div", {
              className: "submit"
            }, _this6.node.node.permissions.reply ? _react.default.createElement("a", {
              className: "btn btn-link",
              onClick: _this6.doReply,
              href: "javascript:void(0)"
            }, _react.default.createElement("span", {
              className: "material-icons",
              "data-icon": "reply"
            }), "\xA0 Reply") : null, _this6.node.node.permissions.delete ? _react.default.createElement("a", {
              className: "btn btn-link",
              onClick: _this6.doDelete,
              href: "javascript:void(0)"
            }, _react.default.createElement("span", {
              className: "material-icons",
              "data-icon": "delete"
            }), "\xA0 Delete") : null))
          }, _react.default.createElement(EventScheduleBody, {
            node: _this6.node.node
          }, _this6.node.node.comment)), !_this6.state.collapsed ? _react.default.createElement("section", {
            className: _classList.default.join('child-comments', _this6.state.expanded && 'open')
          }, _react.default.createElement("div", {
            className: "sub-comment-list"
          }, _this6.node.children.length ? _this6.node.children.map(function (child, index) {
            return _react.default.createElement(_Discussion.DiscussionNode, {
              Element: index == _this6.node.children.length - 1 ? Element : NullFn,
              discussion: _this6.discussion,
              trackData: _this6.trackData,
              key: child.node.id,
              commentPosted: _this6.commentPosted,
              node: child
            });
          }) : null), _react.default.createElement(Target, null, _this6.node.node.permissions.reply ? _react.default.createElement("div", {
            className: _classList.default.join('comment-form', _this6.node.node.permissions.moderate ? 'schedule-form' : '')
          }, _react.default.createElement(_commentForm.default, {
            placeholder: "Enter a reply...",
            submitComment: _this6.submitComment,
            submitting: _this6.state.submitting,
            userProfile: _this6.state.userProfile,
            gotCommentField: _this6.gotCommentField,
            acceptEmptyComment: _this6.state.action != 'reply'
          }), _this6.node.node.permissions.moderate ? _react.default.createElement("div", {
            className: "comment-form-actions"
          }, _react.default.createElement("div", {
            className: "setup-time"
          }, _react.default.createElement("div", {
            className: "checkbox"
          }, _react.default.createElement("label", null, _react.default.createElement("input", {
            type: "checkbox",
            checked: _this6.state.action == 'eventScheduleResponse',
            onClick: _this6.toggleAction
          }), "Propose an event time")), _this6.state.action == 'eventScheduleResponse' && _react.default.createElement(DateTime, {
            id: "eventTime",
            text: "Start day / time",
            minimumValue: _this6.minimumValue,
            required: true,
            timeZone: _this6.state.timeZone,
            value: _this6.state.startTime,
            setValue: _this6.setTime
          }), _this6.state.action == 'eventScheduleResponse' && _react.default.createElement(TimeZone, {
            id: "eventZone",
            text: "Timezone",
            currentTime: _this6.state.startTime,
            setValue: _this6.setZone,
            required: true,
            value: _this6.state.timeZone
          }))) : null) : null)) : null);
        });
      }

      return null;
    }
  }, {
    key: "toggleAction",
    value: function toggleAction(event) {
      this.setState({
        action: event.target.checked ? 'eventScheduleResponse' : 'reply'
      });
    }
  }, {
    key: "setZone",
    value: function setZone(_, zone) {
      this.setState({
        timeZone: zone
      });
    }
  }, {
    key: "setTime",
    value: function setTime(_, time) {
      this.setState({
        startTime: time
      });
    }
  }, {
    key: "doDelete",
    value: function doDelete(event) {
      var _this7 = this;

      (0, _fetch.default)('data/discussion/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.node.node.id,
          trackData: this.trackData
        })
      }).then(function () {
        (0, _noty.showNotificationText)('The scheduling request has been deleted.');

        _this7.commentPosted();
      });
      if (event) event.preventDefault();
      return false;
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(field) {
      this.commentField = field;
    }
  }, {
    key: "toggleExpando",
    value: function toggleExpando() {
      this.setState(function (st) {
        return {
          expanded: !st.expanded
        };
      });
    }
  }, {
    key: "doReply",
    value: function doReply() {
      var _this8 = this;

      this.setState({
        expanded: true
      }, function () {
        _this8.commentField.focus();
      });
    }
  }]);
  return EventScheduleNode;
}(_react.Component), _temp3), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "defaultCollapsed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "profileUpdatedEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "profileUpdatedEvent"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "profileUpdated"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "submitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "submitComment"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setAction", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setAction"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "expand", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "expand"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "toggleAction", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "toggleAction"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setZone", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setZone"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setTime", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setTime"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "doDelete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "doDelete"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "gotCommentField"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "toggleExpando", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "toggleExpando"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "doReply", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "doReply"), _class7.prototype)), _class7);
exports.default = EventScheduleNode;